(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.controller-property-esg
  (:require
   [clojure.edn :as edn]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.controller :as controller]))


(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  (merge (controller/->ui-data props)
         {:energy-performance-certificate-at-acquisition (get-in dynamic-data [:energy-performance-certificate-at-acquisition])
          :energy-performance-certificate-target (get-in dynamic-data [:energy-performance-certificate-target])
          :energy-performance-status    (report-ctl/rich-content props :energy-performance-status)
          :green-building-certification (get-in dynamic-data [:green-building-certification])
          :green-building-status        (report-ctl/rich-content props :green-building-status)
          :eu-taxonomy-alignment        (get-in dynamic-data [:eu-taxonomy-alignment])
          :eu-taxonomy-plan             (report-ctl/rich-content props :eu-taxonomy-plan)
          :other-esg-development        (report-ctl/rich-content props :other-esg-development)}
  ))
